import React from 'react';
import { Link } from 'react-router-dom';
import './Portales.css';
import adminImg from './image/Teachers/1.jpeg';
import laboralImg from './image/PracticalApproach/2.jpeg';
import estudiantilImg from './image/TechnicalPrograms/1.jpeg';

interface Portal {
  label: string;
  description: string;
  image: string;
  to?: string;
  href?: string;
}

const PORTALS: Portal[] = [
  {
    label: 'Portal Administrativo',
    description: 'Gestión de información, procesos y recursos institucionales.',
    image: adminImg,
    to: '/portal-virtual',
  },
  {
    label: 'Portal Laboral',
    description: 'Espacio para docentes: registro de notas y gestión de sus cursos.',
    image: laboralImg,
    to: '/portal-laboral',
  },
  {
    label: 'Portal Estudiantil',
    description: 'Notas, horarios y recursos académicos para estudiantes.',
    image: estudiantilImg,
    to: '/portal-estudiantil',
  },
];

const PortalCardContent: React.FC<{ portal: Portal; available: boolean }> = ({ portal, available }) => (
  <>
    <div className="portales-card-image">
      <img src={portal.image} alt={portal.label} loading="lazy" />
      {!available && <span className="portales-card-soon">Próximamente</span>}
    </div>
    <div className="portales-card-body">
      <h3 className="portales-card-title">{portal.label}</h3>
      <p className="portales-card-desc">{portal.description}</p>
    </div>
  </>
);

const Portales: React.FC = () => (
  <div className="portales-page">
    <div className="portales-header">
      <span className="portales-badge">Acceso en línea</span>
      <h1 className="portales-title">Portales CECAP</h1>
      <p className="portales-intro">Elige el portal al que deseas ingresar.</p>
    </div>

    <div className="portales-grid">
      {PORTALS.map(portal => {
        if (portal.to) {
          return (
            <Link key={portal.label} to={portal.to} className="portales-card">
              <PortalCardContent portal={portal} available />
            </Link>
          );
        }
        if (portal.href) {
          return (
            <a
              key={portal.label}
              href={portal.href}
              target="_blank"
              rel="noopener noreferrer"
              className="portales-card"
            >
              <PortalCardContent portal={portal} available />
            </a>
          );
        }
        return (
          <div key={portal.label} className="portales-card is-disabled" aria-disabled="true">
            <PortalCardContent portal={portal} available={false} />
          </div>
        );
      })}
    </div>
  </div>
);

export default Portales;
